<template>
  <div class="table">
    <div class="table-header">
      <div class="title">{{ ts('Product / Activity /Service')['Product / Activity /Service'] }}</div>
    </div>
    <div class="table-content">
      <el-table :data="productChooseList" :border="false" style="width: 100%">
        <el-table-column>
          <template slot-scope="scope">
            <div class="col-del" @click="handleDelete(scope.$index)">{{ ts('Delete')['Delete'] }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="ts('Name')['Name']" prop="name" align="center"></el-table-column>
        <el-table-column :label="ts('Price')['Price']" prop="price" align="center"></el-table-column>
        <el-table-column :label="ts('Unit')['Unit']" prop="quantity" align="center"></el-table-column>
        <el-table-column :label="ts('Amount')['Amount']" align="center">
          <template slot-scope="scope">{{ scope.row.amount ? `${currency} ${scope.row.amount}` : '-' }}</template>
        </el-table-column>
      </el-table>
      <ul class="price-list">
        <li>
          <span class="label">{{ ts('Product/Activity/Service Total')['Product/Activity/Service Total'] }}: </span>
          <span class="value">{{ currency }} {{ totalPrice }}</span>
        </li>
      </ul>
      <div class="choose" v-if="categoryList.length > 0">
        <div class="title">{{ ts('Would you like to choose any of the following?')['Would you like to choose any of the following?'] }}</div>
        <div class="choose-item" v-for="cat in categoryList" :key="cat.name">
          <div class="item-title">{{ cat.name }} :</div>
          <ul>
            <li :class="{ active: curProduct == item.pageProductId }" v-for="item in cat.list" :key="item.pageProductId" @click="getList(item.pageProductId)">{{ item.pageProductName_translate }}</li>
          </ul>
        </div>
        <div class="activity-list" :class="{ 'product-list': productType == '1', 'service-list': productType == '3' }" v-if="productChooseShow">
          <template v-if="productList.length > 0">
            <ProductItem v-for="(item, index) in productList" :key="index" :item="item" type="select" :hotelId="hotelId" />
          </template>
          <el-empty :image-size="120" v-else></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 酒店下单中的产品选择
import { getAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import ProductCategory from '@/mixins/ProductCategory'
import ProductItem from '@/components/ProductItem.vue'

export default {
  name: 'ProductSelect',
  props: ['hotelId', 'currency'],
  mixins: [ProductCategory, LanguagePackage],
  components: {
    ProductItem,
  },
  data() {
    return {
      productList: [],
      productType: null,
      isShow: false,
      curProduct: null,
    }
  },
  created() {},
  computed: {
    productChooseList: {
      get: function () {
        return this.$store.state.productChooseList
      },
      set: function (newValue) {
        this.$store.commit('setProductList', newValue)
      },
    },
    productChooseShow: {
      get: function () {
        return this.$store.state.productChooseShow
      },
      set: function (newValue) {
        this.$store.commit('setProductChooseShow', newValue)
      },
    },
    totalPrice() {
      let total = 0
      if (this.productChooseList.length > 0) {
        this.productChooseList.forEach((item) => {
          total += item.amount
        })
      }
      return total
    },
  },
  methods: {
    // 查询产品列表
    getList(pageId) {
      if (this.curProduct == pageId) {
        this.productChooseShow = false
        this.productList = []
        this.productType = null
        this.curProduct = null
      } else {
        this.curProduct = pageId
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        getAction(`/pc/home/qryProductList`, {
          pageId,
        })
          .then((res) => {
            this.productList = res.result.singleProductList
            this.productType = res.result.pmsProductPage.productType
            this.productChooseShow = true
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      }
    },
    // 删除房型
    handleDelete(index) {
      this.productChooseList.splice(index, 1)
    },
    next() {
      // productChooseList 数据
      let productChooseList = this.productChooseList
      productChooseList = productChooseList.map((item) => {
        delete item.price
        delete item.amount
        return item
      })
      this.$emit('next', this.totalPrice, productChooseList)
      this.curProduct = null
    },
  },
}
</script>

<style scoped lang="sass"></style>
